import { Box, Button, Tooltip, Typography, useTheme } from '@mui/material';
import React, {
  createElement,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

import CreateIcon from '@mui/icons-material/Create';
import { tokens } from '../../global/theme/tokens';
import { useTranslation } from 'react-i18next';

const demoVariants = [
  {
    label: 'test',
    Icon: CreateIcon,
    content: <Box>Demo</Box>,
    onSelect: () => {},
  },
];

export const ExoVariants = forwardRef(
  ({ variants = demoVariants, onLoaded = () => {}, size }, ref) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
    const { t } = useTranslation();

    const [selected, setSelected] = useState(null);

    useImperativeHandle(ref, () => ({
      reset: handleReset,
      set: handleSet,
    }));

    function handleReset() {
      setSelected(null);
    }

    function handleSet(key) {
      const newSelected = variants.find((obj) => obj.key === key);
      setSelected(newSelected);
    }

    useEffect(() => {
      onLoaded();
    }, []);

    return (
      <>
        {!selected && (
          <Box className=" overflow-y-auto flex-wrap w-full flex h-full flex-row gap-4 justify-center items-center content-center p-4">
            {variants.map((variant) => {
              const isDisabled = variant.disabled === true;
              const buttonContent = (
                <Button
                  key={variant.key || variant.label}
                  onClick={() => {
                    if (isDisabled) return;
                    if (variant.onSelect) variant.onSelect(variant);
                    setSelected(variant);
                  }}
                  disabled={isDisabled}
                  sx={{
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  <Box
                    className=" w-48 rounded-lg  flex flex-col justify-center items-center hover:scale-105 transition-transform"
                    sx={{
                      backgroundColor: colors.card,
                      gap: size === 'small' ? '5px' : '10px',
                      paddingY: size === 'small' ? '10px' : '30px',
                      filter: isDisabled ? 'grayscale(100%)' : 'none',
                    }}
                  >
                    {variant.Icon ? (
                      createElement(variant.Icon, {
                        sx: { fontSize: size === 'small' ? '30px' : '80px' },
                      })
                    ) : variant.icon ? (
                      <img
                        src={variant.icon}
                        alt={variant.label}
                        style={{
                          height: size === 'small' ? '30px' : '80px',
                          objectFit: 'contain',
                        }}
                      />
                    ) : null}
                    <Typography fontSize={size === 'small' ? '16px' : '19px'}>
                      {variant.label}
                    </Typography>
                  </Box>
                </Button>
              );

              if (isDisabled && variant.disabledMessage) {
                return (
                  <Tooltip
                    key={variant.key || variant.label}
                    title={t(variant.disabledMessage)}
                    arrow
                  >
                    <span>{buttonContent}</span>
                  </Tooltip>
                );
              }

              return buttonContent;
            })}
          </Box>
        )}
        {selected && selected.content}
      </>
    );
  }
);
